/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreProjectUserCreateDto } from '../../models/core-project-user-create-dto';
import { CoreProjectUserResponseDto } from '../../models/core-project-user-response-dto';

export interface ProjectUsersControllerCreate$Params {
  tenant: string;
      body: CoreProjectUserCreateDto
}

export function projectUsersControllerCreate(http: HttpClient, rootUrl: string, params: ProjectUsersControllerCreate$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectUserResponseDto>> {
  const rb = new CoreRequestBuilder(rootUrl, projectUsersControllerCreate.PATH, 'post');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CoreProjectUserResponseDto>;
    })
  );
}

projectUsersControllerCreate.PATH = '/o2-core/project-users/{tenant}';
